export const lunaDecimals = 6;
